import React from "react";
import { usePage } from "@inertiajs/react";
import { TranslationProvider } from "@/components/TranslationContext";
import ScrollToFirstError from "@/components/ScrollToFirstError";

/**
 * Global layout that provides translations reactively.
 * usePage() re-renders on every Inertia navigation, so translations always fresh.
 */
const AppLayout = ({ children }: { children: React.ReactNode }) => {
    const { translations } = usePage().props as any;
    return (
        <TranslationProvider translations={translations || {}}>
            {/* bug 41: глобально прокручивает к первому полю с ошибкой; на страницах без
                ошибок/форм рендерит null и ничего не делает. */}
            <ScrollToFirstError />
            {children}
        </TranslationProvider>
    );
};

export default AppLayout;
